import { ReactNode } from "react";
import { can, canAll, canAny, isAdmin } from "./permissions";

type CanProps = {
  admin?: boolean;
  perm?: string;
  anyOf?: string[];
  allOf?: string[];
  fallback?: ReactNode;
  children: ReactNode;
};

export default function Can({
  admin = false,
  perm,
  anyOf = [],
  allOf = [],
  fallback = null,
  children,
}: CanProps) {
  const allowed =
    (!admin || isAdmin()) &&
    (perm ? can(perm) : true) &&
    (anyOf.length ? canAny(anyOf) : true) &&
    (allOf.length ? canAll(allOf) : true);

  if (!allowed) return <>{fallback}</>;
  return <>{children}</>;
}
